import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PersonaDTO } from "app/main/apps/shared/interfaces/persona.interface";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { DialogDocumentosPersonalApoyoComponent } from "../../../../mantenedores/contratista/detalle-contratista/components/dialog-documentos-personal-apoyo/dialog-documentos-personal-apoyo.component";

@Component({
    selector: "app-dialog-personal-apoyo",
    templateUrl: "./dialog-personal-apoyo.component.html",
    styleUrls: ["./dialog-personal-apoyo.component.scss"],
})
export class DialogPersonalApoyoComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DialogPersonalApoyoComponent>,
        @Inject(MAT_DIALOG_DATA)
        public personalApoyo: PersonaDTO[],
        private _dialogSrvc: DialogService
    ) {}

    ngOnInit(): void {}


    verFicha(rut:string){

        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogDocumentosPersonalApoyoComponent,
            "clase-dialog",
            "1000px",
            rut.split('-')[0]
        );
    }
}
